import request from '@/utils/request'


// 查询商品批发列表
export function listWholesale(query) {
  return request({
    url: '/goods/wholesale/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品批发分页
export function pageWholesale(query) {
  return request({
    url: '/goods/wholesale/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品批发详细
export function getWholesale(data) {
  return request({
    url: '/goods/wholesale/detail',
    method: 'get',
    params: data
  })
}

// 新增商品批发
export function addWholesale(data) {
  return request({
    url: '/goods/wholesale/add',
    method: 'post',
    data: data
  })
}

// 修改商品批发
export function updateWholesale(data) {
  return request({
    url: '/goods/wholesale/edit',
    method: 'post',
    data: data
  })
}

// 删除商品批发
export function delWholesale(data) {
  return request({
    url: '/goods/wholesale/delete',
    method: 'post',
    data: data
  })
}

export function batchRejectWholesale(data) {
  return request({
    url: '/goods/wholesale/batchReject',
    method: 'post',
    data: data
  })
}

export function openCustomerWork(data) {
  return request({
    url: '/customer/staff/open-customer-work',
    method: 'get',
    params: data
  })
}

